const translations = {
  'nav.home': 'Inicio',
  'nav.services': 'Servicios',
  'nav.about': 'Nosotros',
  'nav.testimonials': 'Testimonios',
  'nav.faq': 'Preguntas Frecuentes',
  'nav.contact': 'Contacto',
  'nav.bookNow': 'Reservar Ahora',
  
  'hero.title': 'Cuidado Profesional en Casa',
  'hero.subtitle': 'Servicios de Salud en Venezuela',
  'hero.description': 'Brindamos servicios profesionales de cuidado en casa y acompañamiento hospitalario en Venezuela. Asistencia médica personalizada para sus seres queridos con personal calificado disponible 24/7.',
  'hero.ctaPrimary': 'Solicitar Servicio',
  'hero.ctaSecondary': 'Conocer Más',
  
  'services.title': 'Nuestros Servicios',
  'services.subtitle': 'Soluciones de Cuidado Integral',
  'services.selectService': 'Seleccione un Servicio',
  
  'about.title': 'Sobre URI Care',
  'about.subtitle': 'Compromiso con la Excelencia en Salud',
  'about.description': 'URI es una empresa venezolana dedicada a proporcionar servicios de cuidado en casa y acompañamiento hospitalario de la más alta calidad. Nuestro equipo de profesionales capacitados está comprometido con el bienestar de sus seres queridos.',
  
  'testimonials.title': 'Testimonios',
  'testimonials.subtitle': 'Lo Que Dicen Nuestros Clientes',
  
  'faq.title': 'Preguntas Frecuentes',
  'faq.subtitle': 'Respuestas a Sus Dudas',
  
  'contact.title': 'Contáctenos',
  'contact.subtitle': 'Estamos Aquí Para Ayudarle',
  'contact.form.name': 'Nombre Completo',
  'contact.form.email': 'Correo Electrónico',
  'contact.form.phone': 'Teléfono',
  'contact.form.message': 'Mensaje',
  'contact.form.submit': 'Enviar Mensaje',
  'contact.form.success': 'Mensaje enviado exitosamente',
  'contact.form.error': 'Error al enviar mensaje',
  
  'booking.title': 'Reservar Servicio',
  'booking.subtitle': 'Complete el Formulario de Admisión',
  
  'footer.description': 'Servicios profesionales de cuidado en casa y acompañamiento hospitalario en Venezuela. Comprometidos con el bienestar de sus seres queridos.',
  'footer.quickLinks': 'Enlaces Rápidos',
  'footer.services': 'Servicios',
  'footer.contact': 'Contacto',
  'footer.followUs': 'Síguenos',
  'footer.copyright': 'Todos los derechos reservados',
  'footer.poweredBy': 'Desarrollado por Readdy'
};

export default translations;
